import { render, staticRenderFns } from "./FaturasByTypeStatus.vue?vue&type=template&id=07ebd67a"
import script from "./FaturasByTypeStatus.vue?vue&type=script&lang=js"
export * from "./FaturasByTypeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports